var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountDebit = function SvgAccountDebit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M3.967 7.3h15.166c.524 0 .948.424.948.948v10.356a.95.95 0 0 1-.948.948H3.967a.95.95 0 0 1-.948-.948V8.248m.948-.948a.95.95 0 0 0-.948.948m.948-.948a.95.95 0 0 0-.948.948m.948-.948h3.137m-4.085.948v3.156M20.1 15.447v3.157a.947.947 0 0 1-.948.948h-3.156m4.104-8.148V8.248a.95.95 0 0 0-.948-.948h-3.175.019M7.104 19.552H3.948A.95.95 0 0 1 3 18.604v-3.157"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 14.9h17.1v1.9H3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 8,
    r: 3.85,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.198 7h1.197a.47.47 0 0 0 .34-.146.51.51 0 0 0 0-.708.47.47 0 0 0-.34-.146h-.478v-.5c0-.133-.05-.26-.14-.354a.47.47 0 0 0-.34-.146.47.47 0 0 0-.338.146.5.5 0 0 0-.14.354v.525c-.291.062-.55.234-.726.484a1.29 1.29 0 0 0 .162 1.669c.22.207.506.322.803.322h.48c.063 0 .124.026.168.073a.256.256 0 0 1 0 .354.23.23 0 0 1-.169.073H16.48a.47.47 0 0 0-.338.146.51.51 0 0 0 0 .708c.09.093.211.146.338.146h.479v.5c0 .133.05.26.14.354s.212.146.339.146a.47.47 0 0 0 .338-.146.5.5 0 0 0 .14-.354V10a1.2 1.2 0 0 0 .812-.454 1.294 1.294 0 0 0-.17-1.768 1.17 1.17 0 0 0-.88-.278h-.48a.23.23 0 0 1-.169-.073.256.256 0 0 1 0-.354.23.23 0 0 1 .17-.073"
  })));
};
export default SvgAccountDebit;